import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center space-y-6 mb-8">
      {/* Logo Section */}
      <div className="flex justify-center">
        <div className="w-20 h-20 bg-primary rounded-2xl flex items-center justify-center shadow-lg">
          <Icon name="Scale" size={32} color="white" />
        </div>
      </div>

      {/* Brand and Welcome Text */}
      <div className="space-y-3">
        <h1 className="text-3xl font-bold text-foreground">ایران‌داد</h1>
        <p className="text-lg text-muted-foreground">پنل کاربری اسناد حقوقی</p>
      </div>

      {/* Welcome Message */}
      <div className="bg-muted rounded-lg p-4">
        <h2 className="text-xl font-semibold text-foreground mb-2">
          خوش آمدید
        </h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          برای دسترسی به پنل کاربری و مدیریت اسناد حقوقی خود، لطفاً شماره موبایل
          خود را وارد کنید
        </p>
      </div>

      {/* Features List */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
        <div className="flex flex-col items-center space-y-2">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="FileText" size={20} className="text-primary" />
          </div>
          <span className="text-sm font-medium text-foreground">
            مدیریت اسناد
          </span>
        </div>

        <div className="flex flex-col items-center space-y-2">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Zap" size={20} className="text-primary" />
          </div>
          <span className="text-sm font-medium text-foreground">
            تولید سریع
          </span>
        </div>

        <div className="flex flex-col items-center space-y-2">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Shield" size={20} className="text-primary" />
          </div>
          <span className="text-sm font-medium text-foreground">
            امنیت بالا
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;
